import Game from '../../../../Game';
import {
    TActionType,
    TransactionType,
} from '../../../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../../../Utility/Tracking/TrackingHelpers/Transaction';
import { setLives } from '../../../Player/PlayerInventoryHelper';
import { queuePopup } from '../../../UI/UIStateHelper';
import { IGameState } from '../../IGameState';
import { ICustomEntryPoint } from '../GameEntryPoint';

export function sendLife(payload: ICustomEntryPoint, state: IGameState) {
    state = {
        ...state,
        playerState: setLives(state.playerState, state.playerState.lives + 1),
        UIState: queuePopup(state.UIState, 'receiveLivesFriendMenu', {
            title: `${Game.locale.getText('GotLivesFrom')}${payload.userName}`,
            lives: 1,
        }),
    };
    trackTransaction(state, TransactionType.REWARD, TActionType.SOCIAL);
    return state;
}
